import { apiInstance } from "@/utils/api-instance";
import { ENDPOINTS } from "@/utils/constants";

export const listRolePermission = async () => {
    const { data } = await apiInstance.post(ENDPOINTS.PERMISSION_LIST_ROLE);
    return data
}